import { httpCreate } from './http';

const http = httpCreate('/srv/fund-detail-marketing');

export const fundDetailMarketing = {
	// 账单
	getList(params) {
		return http.get('/list', { params });
	},
	typeList(params) {
		return http.get('/typeList', { params });
	},
};
